<template>
  <el-container class="layout" v-loading="$store.state.app.fullLoading" element-loading-spinner="el-icon-loading" :element-loading-text="$store.state.app.loadingText">
    <el-container class="layout-main">
      <div class="layout-right">
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </el-container>
    <v-bottom v-show="!browser"></v-bottom>
  </el-container>
</template>

<script>
import bottom from './components/bottom';
export default {
  name: "layout",
  components: {
    'v-bottom': bottom
  },
  data() {
    return {
      browser: sessionStorage.getItem('browser'),
      width: "200px",
      isRentCompany: true,
      imgurl: {},
    };
  },
  computed: {
    reqUserInfo() {
      return JSON.parse(sessionStorage.getItem('userInfo'));
    },
  },
  methods: {
    handleCollapse(isCollapse) {
      this.width = isCollapse ? "64px" : "200px";
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #ebeef5;

  .layout-header {
    height: 60px;
    padding: 0;
  }

  .layout-main {
    flex: 1;
    overflow: hidden;
  }

  .layout-left {
    transition: width 0.3s;
    // box-shadow: 5px 0 10px -5px #b6b4b4;
  }

  .layout-right {
    flex: 1;
    overflow: hidden;
    background: #eff6f8;
  }
}
</style>
